import CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css'; // CodeMirror CSS
import 'codemirror/mode/xml/xml.js';
import { froalaLangTypes } from '../config/config';

export default ({ translate = () => {}, uploadOptions = {}, clientLangCode }) => {
    return {
        initOnClick: true,
        htmlUntouched: true,
        toolbarSticky: false,
        toolbarBottom: false,
        toolbarInline: false,
        attribution: false,
        linkEditButtons: [
            'buttonStyle',
            '|',
            'textColorEdit',
            'backgroundColorEdit',
            'borderOuterButton',
            'buttonAlign',
            'buttonPadding',
            'buttonEdit',
            'linkOpen',
            'linkEdit',
            'linkRemove'
        ],
        editDivButtons: [
            'divStyle',
            '|',
            'backgroundColorEditDiv',
            'borderOuterDiv',
            'divAlign',
            'divPadding',
            'formatClearButton'
        ],
        imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
        imageEditButtons: [
            'imageReplace',
            'imageCaption',
            'imageRemove',
            '|',
            'imageLink',
            'linkOpen',
            'linkEdit',
            'linkRemove',
            '-',
            'imageDisplay',
            'imageAlt',
            'imageSize'
        ],
        // 刪除 iframeEdit ，新增 videoReplace
        videoEditButtons: [
            'videoReplace',
            'videoRemove',
            '|',
            'videoDisplay',
            'videoAlign',
            'videoSize'
        ],
        quickInsertButtons: ['image', 'table', 'ol', 'ul', 'hr'],
        tableEditButtons: [
            'tableHeader',
            'tableFooter',
            'tableRemove',
            'tableRows',
            'tableColumns',
            'tableStyle',
            '-',
            'tableCells',
            'tableCellBackground',
            'tableCellVerticalAlign',
            'tableCellHorizontalAlign',
            'tableCellStyle'
        ],
        toolbarButtons: {
            moreText: {
                buttons: [
                    'paragraphFormat',
                    'fontFamily',
                    'fontSize',
                    '|',
                    'bold',
                    'textColor',
                    'backgroundColor',
                    'align',
                    'underline',
                    'italic',
                    'strikeThrough',
                    'subscript',
                    'superscript',
                    'clearFormatting',
                    'formatOL',
                    'formatUL',
                    'lineHeight',
                    'indent',
                    'outdent',
                    'customQuote'
                ],
                align: 'left',
                buttonsVisible: 7
            },
            moreRich: {
                buttons: [
                    'insertLink',
                    'insertTable',
                    'insertImage',
                    'customButton',
                    'containerIcon',
                    'emoticons',
                    'specialCharacters',
                    'insertHR'
                ],
                align: 'left',
                buttonsVisible: 5
            },
            moreMisc: {
                buttons: ['undo', 'redo', 'html']
            },
            align: 'right',
            buttonsVisible: 2
        },
        paragraphStyles: {
            'cover-title': 'cover-title',
            'section-title': 'section-title',
            'section-subtitle': 'section-subtitle',
            'inner-title': 'inner-title',
            inner: 'inner',
            caption: 'caption'
        },
        paragraphMultipleStyles: false,
        paragraphFormatSelection: true,
        paragraphFormat: {
            H1: translate({
                id: 'froala.h1',
                defaultMessage: '標題1'
            }),
            H2: translate({
                id: 'froala.h2',
                defaultMessage: '標題2'
            }),
            H3: translate({
                id: 'froala.h3',
                defaultMessage: '標題 3'
            }),
            H4: translate({
                id: 'froala.h4',
                defaultMessage: '標題4'
            }),
            N: translate({
                id: 'froala.body_text',
                defaultMessage: '內文'
            }),
            DIV: translate({
                id: 'froala.caption',
                defaultMessage: '說明'
            })
        },
        tableStyles: {
            'fr-alternate-rows': translate({
                id: 'froala.alternative_rows',
                defaultMessage: '交替行'
            }),
            'froala-thin-borders': translate({
                id: 'froala.thin-borders',
                defaultMessage: '細邊框'
            }),
            'froala-thick-borders': translate({
                id: 'froala.thick_borders',
                defaultMessage: '粗邊框'
            }),
            'fr-dashed-borders': translate({
                id: 'froala.table_dashed',
                defaultMessage: '虛邊框'
            }),
            'froala-no-borders': translate({
                id: 'froala.no_borders',
                defaultMessage: '透明邊框'
            })
        },
        lineHeights: {
            Default: '',
            Single: '1',
            1.15: '1.15',
            1.5: '1.5',
            Double: '2'
        },
        lineBreakerTags: [
            'table',
            'hr',
            'form',
            'dl',
            'span.fr-video',
            '.fr-embedly',
            '.fr-img-caption',
            'div.custom-div',
            'p',
            'br'
        ],
        fontFamily: {
            'Noto Serif TC': translate({
                id: 'froala.noto_serif_tc',
                defaultMessage: '思源宋體'
            }),
            'Noto Sans TC': translate({
                id: 'froala.noto_sans_tc',
                defaultMessage: '思源黑體'
            }),
            'Arial,Helvetica,sans-serif': 'Arial',
            'Georgia,serif': 'Georgia',
            "'Times New Roman',Times,serif": 'Times New Roman',
            'Tahoma,Geneva,sans-serif': 'Tahoma',
            'Verdana,Geneva,sans-serif': 'Verdana',
            Oswald: 'Oswald',
            Montserrat: 'Montserrat',
            'Impact,Charcoal,sans-serif': 'Impact',
            'Noto Serif JP': translate({
                id: 'froala.noto_serif_jp',
                defaultMessage: '源ノ明朝'
            }),
            'Noto Sans JP': translate({
                id: 'froala.noto_sans_jp',
                defaultMessage: '源ノ角ゴシック'
            })
        },
        fontFamilySelection: true,
        ...(clientLangCode === froalaLangTypes.JA_JP
            ? { fontFamilyDefaultSelection: 'Noto Sans JP' }
            : {}),
        fontSizeSelection: true,
        linkInsertButtons: [],
        charCounterCount: false,
        wordCounterCount: false,
        placeholderText: '',
        imageMaxSize: 3 * 1000 * 1000,
        imageUploadURL: uploadOptions.imageUploadURL,
        imageUploadParams: {
            ...uploadOptions.imageUploadParams
        },
        requestHeaders: {
            ...uploadOptions.requestHeaders
        },
        imageUploadParam: uploadOptions.imageUploadParam,
        codeMirror: CodeMirror,
        codeMirrorOptions: {
            lineNumbers: true,
            lineWrapping: true,
            mode: 'text/html',
            tabSize: 2
        },
        pasteDeniedAttrs: ['id'] // 解決複製貼上造成 class 遺失
    };
};
